import { useEffect, useState } from "react";
import UpdateTipIcon from "@/assets/common/ic_updateTip.png";
import appStore from "@/store/app.store";
import {
  openUpgrateWindow,
  subscribeUpgrateWindowFocusStatus,
} from "@/utils/window";
import "./HeaderUpdateTip.less";
import fridayReporter from "@/utils/friday";

function HeaderUpdateTip() {
  const hasUpdate = appStore((state) => state.hasUpdate);
  const newVersion = appStore((state) => state.newVersion);
  const currentVersion = appStore((state) => state.currentVersion);

  const [hasFocusUpdateWindow, setHasFocusWindow] = useState(false);

  useEffect(() => {
    subscribeUpgrateWindowFocusStatus((data) => {
      setHasFocusWindow(data.data);
    });
  }, []);

  useEffect(() => {
    if (hasUpdate && newVersion && currentVersion) {
      console.log("版本有更新", currentVersion, newVersion);
      fridayReporter.pushData({
        eventCode: "HomePage_upgrade_check",
        payload: {
          origin_version: currentVersion,
          target_version: newVersion,
        },
      });
    }
  }, [hasUpdate, newVersion, currentVersion]);

  return (
    hasUpdate &&
    !hasFocusUpdateWindow && (
      <div
        className="update-tip-container no_drag flex px-1 h-7 items-center justify-center rounded-2 bg-#fff cursor-pointer mr-6"
        onClick={() => {
          openUpgrateWindow();
        }}
      >
        <img
          src={UpdateTipIcon}
          className="size-5 cursor-pointer relative z-2"
        />
        <div className="update-tip-text pl-1 font-500 text-3">立即重启更新</div>
      </div>
    )
  );
}

export default HeaderUpdateTip;
